<template>
  <div>
    <div class="mt-5 text-center padding-box">
      <!-- <h3 class="text-bgreen-200 fw-bold">รายการที่ต้องกรอก</h3> -->
      <!-- <h5 class="text-bgreen-200 fw-normal text-start">ชื่ออาคาร</h5> -->
      <h4 class="text-start fw-bold" style="color: #265054">
        <router-link to="/buildings"
          ><img src="@/assets/mobile/arrow-left.svg" alt=""
        /></router-link>
        {{ buildingName }}
      </h4>
      <div class="box rounded-pill p-0">
        <div class="d-flex">
          <div
            v-for="(tab, index) in tabs"
            :key="index"
            class="w-100 rounded-pill p-2"
            :class="{
              'bg-bblack-100 text-white': tab.id == activeTab,
              'text-black-100': tab.id != activeTab,
            }"
            @click="handleActiveTab(tab.id)"
          >
            <div>
              {{ tab.name }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="listsFillIn && listsFillIn.length > 0" class="mt-4">
        <div
          v-for="(list, index) in listsFillIn"
          :key="index"
          class="box rounded-3 px-3 py-2"
        >
          <div class="" @click="navigationToDetailDaily(list)">
            <div class="d-flex my-auto gap-4">
              <div>
                <img
                  v-if="checkImageList(list)"
                  :src="
                    require(`@/assets/mobile/fillin/${checkImageList(list)}`)
                  "
                  style="max-width: 100px"
                />
                <img
                  v-else
                  :src="require(`@/assets/mobile/fillin/product.png`)"
                  style="max-width: 100px"
                />
              </div>

              <div class="text-start">
                <span class="d-flex align-items-center text-bblack-100 fs-5">
                  {{ list ? list.name : "" }}
                </span>
              </div>
            </div>

            <div class="d-flex align-items-center mt-2 gap-2">
              <span
                class="text-white py-1 px-2 rounded-pill text-center"
                :class="{
                  'bg-day': list.frequency_type.value == 0,
                  'bg-month': list.frequency_type.value == 1,
                  'bg-year': list.frequency_type.value == 2,
                  'bg-event': list.frequency_type.value == 3,
                }"
                style="font-size: 0.8rem"
              >
                {{ filloutType(list.frequency_type.value) }}
              </span>
              <span
                class="py-1 px-2 rounded-pill text-center"
                style="background: #f0f6fb; font-size: 0.8rem"
              >
                {{ inputTypeName(list.input_type) }}
              </span>
            </div>
            <hr class="my-2" />
            <div class="d-flex text-bblack-100 mb-1">
              <span class="fw-bold">ข้อมูลล่าสุด</span>
              <span class="ms-auto">
                {{
                  list.recent_measure_list_history
                    ? `${formatThaiDate(list.recent_measure_list_history.date)}`
                    : "-"
                }}
              </span>
              <!-- <span class="ms-auto"
                >{{
                  list && list.last_history_updated_at
                    ? dateTimeTh(list.last_history_updated_at)
                    : "-"
                }}
                ({{
                  list && list.last_history_updated_at
                    ? timeThai(list.last_history_updated_at)
                    : "-"
                }})</span
              > -->
            </div>
          </div>
        </div>
      </div>
      <div v-else class="box rounded-3 p-3 mt-5 fw-bold">
        <LoadingVue v-if="isLoading" class="mx-auto" />
        <div
          v-if="listsFillIn && listsFillIn.length <= 0"
          class="mx-auto fw-bold"
        >
          ไม่พบข้อมูล
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { httpClient } from "@/token/axios.js";
import helper from "@/mixins/helper";
import LoadingVue from "@/components/LoadingMask.vue";
import { apiURL } from "@/configs/serverConfig";
export default {
  components: {
    LoadingVue,
  },
  mixins: [helper],
  data() {
    return {
      tabs: [
        { id: 1, name: "รายการที่ต้องกรอก" },
        { id: 2, name: "รายการทั้งหมด" },
      ],
      activeTab: "",
      locationId: "",
      listsFillIn: null,
      imageFillIn: [
        { name: "ผลผลิต", img_name: "product.png", type: "ผลผลิต" },
        { name: "ไฟฟ้า", img_name: "electricity.png", type: "ไฟฟ้า" },
        { name: "ไอน้ำ", img_name: "steaming.png", type: "ไอน้ำ" },
        { name: "น้ำ", img_name: "water.png", type: "น้ำ" },
        { name: "น้ำประปา", img_name: "water.png", type: "น้ำ" },
        { name: "น้ำบาดาล", img_name: "water.png", type: "น้ำ" },
        {
          name: "ไฟฟ้าเครื่องเย็น",
          img_name: "electricity.png",
          type: "ไฟฟ้า",
        },
        {
          name: "ไฟฟ้าเครื่องจักร",
          img_name: "electricity.png",
          type: "ไฟฟ้า",
        },
        { name: "เครื่องเย็นใหม่", img_name: "electricity.png", type: "ไฟฟ้า" },
        { name: "เครื่องจักรใหม่", img_name: "electricity.png", type: "ไฟฟ้า" },
        {
          name: "เครื่องจักร Maingen",
          img_name: "electricity.png",
          type: "ไฟฟ้า",
        },
        { name: "น้ำ 1", img_name: "water.png", type: "น้ำ" },
        { name: "น้ำ 2", img_name: "water.png", type: "น้ำ" },
        { name: "น้ำ evap", img_name: "water.png", type: "น้ำ" },
        { name: "น้ำ evap เก่า", img_name: "water.png", type: "น้ำ" },
        { name: "น้ำ evap ใหม่", img_name: "water.png", type: "น้ำ" },
        { name: "น้ำโรงซัก", img_name: "water.png", type: "น้ำ" },
      ],
      buildingName: null,
      isLoading: false,
    };
  },
  created() {
    this.locationId = this.$route.params.id;
    this.handleActiveTab(1);
    this.buildingName = this.$route.query.building;
  },
  methods: {
    async handleActiveTab(tab) {
      this.isLoading = true;
      this.activeTab = tab;

      // const url = `${apiURL}/location/ghg?location_id=${this.locationId}&ghg_roles=1&ghg_roles=2`;
      let params = null;
      if (tab == 1) {
        params = {
          is_assign: true,
          is_not_last_update_history: true,
          sort: "measure_lists.name",
          building_id: this.locationId,
          is_validate: true,
        };
      } else {
        params = {
          is_assign: true,
          sort: "measure_lists.name",
          building_id: this.locationId,
          is_validate: true,
        };
      }

      const url = `${apiURL}/measure_list`;

      try {
        const getListFillIn = await httpClient.get(url, { params: params });
        this.listsFillIn = getListFillIn.data.entities;
        // console.log('listsFillIn',this.listsFillIn);
        // this.listsFillIn.sort(function (a, b) {
        //   return new Date(b.created_at) - new Date(a.created_at);
        // });
      } catch (err) {
        console.log(err);
      }
      // setTimeout(() => {
      this.isLoading = false;
      // }, 5000);
    },
    checkDateForFill(fillDate) {
      // fillData
      let currentDate = Date.now();
      let date1 = new Date(helper.methods.formatDateTh(currentDate)).getTime();
      let date2 = new Date(helper.methods.formatDateTh(fillDate)).getTime();

      if (date1 < date2) {
        return true;
      } else if (date1 > date2) {
        return false;
      } else {
        return true;
      }
    },
    checkImageList(list) {
      for (let img of this.imageFillIn) {
        if (img.name == list.name) {
          return img.img_name;
        }
      }
    },
    checkTypeList(list) {
      for (let img of this.imageFillIn) {
        if (img.name == list.name) {
          return img.type;
        }
      }
    },
    async navigationToDetailDaily(list) {
      // await this.$cookies.set("role", list.role.role, "1D");
      // await this.$cookies.set("created_at", list.start_input_at, "1D");
      await this.$router.push(
        `/detail-daily/${this.locationId}/${list.id}?name=${list.name}&building=${this.buildingName}
        &input_type=${list.input_type}&start_fillin=${list.start_input_at}&frequency_type=${list.frequency_type.value}&unit=${list.unit.name_th}`
      );
    },

    filloutType(frequency_type) {
      let type = null;
      switch (frequency_type) {
        case 0:
          type = "กรอกแบบรายวัน";
          break;
        case 1:
          type = "กรอกแบบรายเดือน";
          break;
        case 2:
          type = "กรอกแบบรายปี";
          break;
        case 3:
          type = "กรอกแบบรายอีเว้นท์";
          break;
      }

      return type;
    },
  },
};
</script>
<style lang="scss" scoped>
.text-header {
  font-size: 3em;
}

.bg-day {
  background: #51646b;
}

.bg-month {
  background: #4804d9;
}

.bg-year {
  background: #1d273f;
}

.bg-event {
  background: #ff8500;
}
</style>
